import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IUniform } from "../uniformModel";

export const getAllUniform = createAsyncThunk(
  "Uniforms/FindAllUniforms",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/FindAllUniforms`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Uniform:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createUniform = createAsyncThunk(
  "Uniforms/InsertUniforms",
  async (UniformData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/InsertUniforms`,
        UniformData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Uniform:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateUniform = createAsyncThunk(
  "Uniforms/UpdateUniforms",
  async (UniformData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/UpdateUniforms`,
        UniformData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Uniform:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteUniform = createAsyncThunk(
  "Uniforms/DeleteUniforms",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/DeleteUniforms`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Uniform :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getUniformByID = createAsyncThunk(
  "Uniforms/FindByIDUniforms",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/FindByIDUniforms`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        IndustriesID: result?.IndustriesID,
        Title: result?.Title,
        Description: result?.Description,
        SequenceNo: result?.SequenceNo,
        Image: result?.Image,
        IsActive: result.IsActive ? 1 : 2,
      } as IUniform;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Uniform :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveUniform = createAsyncThunk(
  "Uniforms/FindAllActiveUniforms",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Uniforms/FindAllActiveUniforms`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Uniform:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveUniform = createAsyncThunk(
  "Uniforms/ActiveInActiveUniforms",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/ActiveInActiveUniforms`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Uniform :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const UniformImageUpload = createAsyncThunk(
  "Uniforms/UniformsImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Uniforms/UniformsImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Uniform Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
